import { Routes } from '@angular/router';
import { entityProfileTypeGuard } from '../guards/entity-profile/entity-profile-type.guard';

export const profileRoutes: Routes = [
  {
    path: 'property',
    loadChildren: () => import('@rma/addresses/address-profile'),
  },
  {
    path: 'real-estate-agent/:profile-name/sales',
    loadChildren: () => import('@rma/profiles/agent').then((m) => m.agentProfileRoutes),
  },
  {
    path: 'mortgage-broker/:profile-name/finance',
    loadChildren: () => import('@rma/profiles/mortgage-broker').then((m) => m.mortgageBrokerProfileRoutes),
  },
  {
    path: 'real-estate-agency/:profile-name',
    children: [
      {
        path: 'sales',
        loadChildren: () => import('@rma/profiles/agency-sales').then((m) => m.agencyProfileRoutes),
      },
      {
        path: 'leasing',
        loadChildren: () => import('@rma/profiles/agency-leasing').then((m) => m.agencyProfileRoutes),
      },
      {
        path: 'leasing/property-listings',
        loadChildren: () => import('@rma/campaigns/profile'),
        data: {
          isLeasing: true,
        },
      },
      {
        path: 'property-listings',
        loadChildren: () => import('@rma/campaigns/profile'),
      },
      //Pangea review code support
      //The `/p` is for Pangea
      {
        path: ':vertical/reviews/p',
        loadChildren: () => import('@rma/reviews/review').then((m) => m.pangeaReviewRoutes),
      },
      //Legacy review code support
      {
        path: ':vertical/reviews',
        loadChildren: () => import('@rma/reviews/review').then((m) => m.legacyReviewRoutes),
      },
    ],
  },
  //Pangea review code support
  //The `/p` is for Pangea
  {
    path: ':entity-profile-type/:profile-name/reviews/p',
    loadChildren: () => import('@rma/reviews/review').then((m) => m.pangeaReviewRoutes),
    canMatch: [entityProfileTypeGuard],
  },
  // this is the same for all profile types
  {
    path: ':entity-profile-type/:profile-name/reviews',
    loadChildren: () => import('@rma/reviews/review').then((m) => m.legacyReviewRoutes),
    canMatch: [entityProfileTypeGuard],
  },
];
